// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ILKp","buttons":"styles_buttons__CJLKp"};